import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'minutesAgo',
})
export class MinutesAgoPipe implements PipeTransform {
  transform(value: Date | string | number, viewType: string = 'time',endDate?:Date|string): any {
    const now =endDate ? new Date(endDate).getTime() : Date.now();
    const inputTime = new Date(value).getTime();

    let diffMs = now - inputTime;

    if (Number.isNaN(diffMs) || diffMs < 0) {
      return '00:00';
    }

    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    diffMs %= (1000 * 60 * 60);

    const minutes = Math.floor(diffMs / (1000 * 60));

    const diffMin = Math.floor((+now - +inputTime) / 1000 / 60);
    const pad = (num: number): string => num.toString().padStart(2, '0');

    switch (viewType) {
      case 'time':
        return `${pad(hours)}:${pad(minutes)}`;
      case 'minute':
        return diffMin;
    }

    if (viewType == 'time') {
      return `${pad(hours)}:${pad(minutes)}`;
    }
  }
}
